import { createInitializeStoresFunction, createGetStoreFunction } from './helpers';
import { ObjectStore, CollectionStore } from '@utils/orm';

export const GLOBAL_STORE_KEYS = {
  globalStateStore: 'globalStateStore',
  bookmarkStore: 'globalBookmarkStore',
  bookmarkCollectionStore: 'globalBookmarkCollectionStore',
  bookmarkCollectionSelectedStore: 'globalBookmarkCollectionSelectedStore',
  recRequestGroupStore: 'globalRecRequestGroupStore',
  reportContentStore: 'globalreportContentStore',
};

const GLOBAL_STORE_TYPES = {
  globalStateStore: ObjectStore,
  bookmarkStore: CollectionStore,
  bookmarkCollectionStore: CollectionStore,
  bookmarkCollectionSelectedStore: ObjectStore,
  recRequestGroupStore: ObjectStore,
  reportContentStore: ObjectStore,
};

export const initializeGlobalStores = createInitializeStoresFunction(GLOBAL_STORE_KEYS, GLOBAL_STORE_TYPES);
export const getGlobalStore = createGetStoreFunction(GLOBAL_STORE_KEYS, GLOBAL_STORE_TYPES);
